import { format, isDate } from 'date-fns'

type DateFormat = 'short_date' | 'medium_date' | 'long_date'

//* This util is created specifically for formatting date for API requests. Do not use this for displaying dates in the UI. Use the translateDate from useLocalisation hook instead.
export const formatDateForAPI = (date: unknown, dateFormat: DateFormat = 'short_date'): string | undefined => {
  if (isDate(date)) {
    if (dateFormat === 'short_date') {
      return format(date, 'yyyy-MM-dd')
    }

    if (dateFormat === 'medium_date') {
      return format(date, 'dd MMM yy')
    }

    if (dateFormat === 'long_date') {
      return format(date, 'yyyy-MM-dd HH:mm')
    }
  }

  return undefined
}
